<div class="container">
  <app-progress-bar [pageNames]="advancedPages" />
  <router-outlet></router-outlet>
</div>
